export default {
  DEFAULT: 'DEFAULT',
  RIGHT_DRAWER: 'RIGHT_DRAWER',
};
